import * as React from 'react';
export const sevenelevenSvg = React.forwardRef(function sevenelevenSvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fill: '#008061',
      d: 'M0 0h32v32H0z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M19.24 26.948v1.049h-6.45v-1.051H7.908c-.477 0-.865-.5-.865-1.117L5 5.114c0-.617.477-1.117 1.066-1.117H25.79c.585 0 1.062.5 1.062 1.117l-2.02 20.715c0 .617-.388 1.117-.865 1.117l-4.728.002Z',
      fill: '#fff',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M8.592 7.03h13.206c-1.3.489-5.258 3.176-6.247 4.983H8.604L8.592 7.03Z',
      fill: '#F5821F',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M19.117 21.308c-.188 1.805-.196 4.002-.196 6.31h-5.724c0-2.308.096-4.505.285-6.31h5.635Zm.531-4.662c.116-1.428 2.066-3.759 3.954-4.371V6.767c-5.196 2.332-8.574 5.858-9.305 9.865l5.351.014Z',
      fill: '#ED1B2D',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M10.263 18.7v.7h-.916v.7h.916v.801H8.17v-3.73h2.093V18h-.916v.7h.916Zm4.865 0v.7h-.912v.7h.912v.801h-2.089v-3.73h2.089V18h-.912v.7h.912Zm5.362 0v.7h-.915v.7h.915v.801h-2.092v-3.73h2.092V18h-.915v.7h.915Zm-8.659-1.53v2.93h.916v.801h-2.093v-3.73h1.177Zm4.986 2.522-.447-2.521h-1.027l.585 3.73h1.512l.707-3.73h-.873l-.457 2.52Zm4.17-2.522h1.13v3.73h-1.13v-3.73Zm1.131 1.108c.061-.408.638-.299.638-.066v2.69h1.135v-3.163c0-.67-.942-.94-1.766-.35l-.007.89Z',
      fill: '#008061',
    }),
  );
});
sevenelevenSvg.defaultProps = {
  width: '32',
  height: '32',
  viewBox: '0 0 32 32',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var seveneleven = {
  category: 'brand',
  colorable: false,
  name: 'seveneleven',
  svg: sevenelevenSvg,
};
